import { render, staticRenderFns } from "./SplitContent.vue?vue&type=template&id=d3fb7b3a&scoped=true"
import script from "./SplitContent.vue?vue&type=script&lang=ts"
export * from "./SplitContent.vue?vue&type=script&lang=ts"
import style0 from "./SplitContent.vue?vue&type=style&index=0&id=d3fb7b3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3fb7b3a",
  null
  
)

export default component.exports